import React, { useState, useEffect } from 'react';
import { getAnnouncements } from '../services/api';
import './AnnouncementBanner.css';

export default function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    getAnnouncements()
      .then(setAnnouncements)
      .catch(() => {});
  }, []);

  if (announcements.length === 0) return null;

  return (
    <div>
      {announcements.map((a) => (
        <div key={a.id} className="announcement-banner">
          <div className="announcement-banner__content">
            <span className="announcement-banner__icon">⚠️</span>
            <span>{a.message}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
